import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: false
})
export class PaginationComponent {
  @Input() displayTotal = true;
  @Input() pageSize = 10;
  @Output() pageChange: EventEmitter<number> = new EventEmitter();

  getFirstItem(currentPage: number) {
    return (currentPage - 1) * this.pageSize + 1;
  }

  getLastItem(currentPage: number, totalItems: number) {
    const maxLastItem = currentPage * this.pageSize;
    return maxLastItem > totalItems ? totalItems : maxLastItem;
  }


}
